import { Button } from "@tellescope/ui";
import { formatName } from "@tellescope/utils";
import { Pencil, Trash2, User } from "lucide-react";
import { useTranslation } from "react-i18next";
import { RelatedContactFormResult } from "./AddRelatedContactForm";

export interface RelatedContactProps {
  contact: RelatedContactFormResult;
  number: number;
  onEdit: () => void;
  onDelete: () => void;
}

export const RelatedContact = ({ contact, number, onEdit, onDelete }: RelatedContactProps) => {
  const { t } = useTranslation("forms");
  const displayName =
    formatName(contact) || contact.email || contact.phoneNumber || t("Unnamed Contact {{number}}", { number });

  return (
    <div className="border flex justify-between rounded-md bg-gray-100 items-center py-1 px-3">
      <div className="flex gap-2 items-center">
        <User className="w-4" />
        <p className="text-sm">{displayName}</p>
      </div>
      <div className="flex items-center">
        <Button variant="ghost" size="icon" onClick={onEdit}>
          <Pencil />
        </Button>
        <Button variant="ghost" size="icon" onClick={onDelete}>
          <Trash2 />
        </Button>
      </div>
    </div>
  );
};
